import { featureFlagsVar } from './reactiveVar';
import { FlagState } from './types';
export function getFeatureFlag(featureKey) {
    const featureValues = featureFlagsVar();
    const isEnabled = featureValues[featureKey].value === FlagState.ENABLED;
    return isEnabled;
}
